import { fetchGetAccounts } from '@iwoca/lapi-client/edge';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';
import { PaymentCardSVG } from '@svgComponents/paymentCardSVG/PaymentCardSVG';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

import messages from './OverduePayments.messages';
import styles from './OverduePayments.module.css';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals';
import DashboardCTA from '../../dashboardComponents/DashboardCTA/DashboardCTA';

export const OverduePayments = ({ accountId }: { accountId?: string }) => {
    const stateKey = useStateKey();

    const { data: account } = useQuery({
        queryKey: ['accounts', stateKey],
        queryFn: () => fetchGetAccounts({ stateKey }),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            )
    });

    const nextRepymentAmount = account?.scheduled_payments?.schedule?.[0].total;

    return (
        <DashboardCTA
            data-testid="overdue-payment-action"
            title={<FormattedMessage {...messages.overdueRepaymentTitle} />}
            icon={<PaymentCardSVG />}
            description={
                <FormattedMessage
                    {...messages.overdueRepayment}
                    values={{
                        overduePaymentAmount: (
                            <span className={styles.overdueAmount}>
                                <MoneyWithDecimals value={nextRepymentAmount} />
                            </span>
                        ),
                        link: (
                            <a
                                href="https://support.iwoca.co.uk/en/articles/1608757-how-we-can-help-if-you-miss-a-payment-or-you-re-struggling-to-repay"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <FormattedMessage
                                    {...messages.overdueRepaymentLink}
                                />
                            </a>
                        )
                    }}
                />
            }
            cta={
                <NEW_IwLinkButton
                    to={{
                        pathname: '/repayment/',
                        search: `?accountId=${accountId}`
                    }}
                >
                    <FormattedMessage {...messages.overdueRepaymentCTA} />
                </NEW_IwLinkButton>
            }
        />
    );
};
